
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.4.1 (12e8fc1502fd2b3958da176868f9f846)",
    buildSeed: 1783969597168,
    "wdosbox-x-jspi.wasm": {
        "size": 7716226,
        "gzSize": 2703372
    },
    "wdosbox-x-jspi.js": {
        "size": 230216,
        "gzSize": 54296
    },
    "wdosbox-x.wasm": {
        "size": 7859183,
        "gzSize": 2753872
    },
    "wdosbox-x.js": {
        "size": 229416,
        "gzSize": 55194
    },
    "wdosbox.wasm": {
        "size": 1459705,
        "gzSize": 501642
    },
    "wdosbox.js": {
        "size": 110662,
        "gzSize": 29302
    },
    "wlibzip.wasm": {
        "size": 112483,
        "gzSize": 52219
    },
    "wlibzip.js": {
        "size": 72957,
        "gzSize": 19326
    }
,
};
